import styled from '@emotion/styled';

export default styled.div`
    background-color: #F3F3F3;
    padding: 5em 0;
`;